module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_3016.0c0fa844.png";